import React from 'react';
import Helmet from 'react-helmet';
import { useConfigContext } from '../../../config-context';

export const SearchResultsSEO = () => {
  const { metaTagsAggregator } = useConfigContext();
  if (metaTagsAggregator) {
    metaTagsAggregator.push(
      `<meta data-meta-tags-aggregator="true" name="robots" content="noindex, nofollow" />`,
    );
  }
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
};
